import { createFileRoute } from "@tanstack/react-router";
import LegalPage from "@/components/LegalPage";
import { buildHead, breadcrumbLD } from "@/content/seo";

const TITLE = "Terms & Conditions · Morningstar Yacht · Vilamoura";
const DESC = "Terms and conditions for private yacht charters aboard Morningstar from Marina de Vilamoura — bookings, cancellations, weather policy, liability and consumer arbitration.";
const PATH = "/terms";

export const Route = createFileRoute("/terms")({
  component: () => (
    <LegalPage
      lang="en"
      title="Terms & Conditions"
      updated="May 2026"
      homeHref="/"
      backLabel="Back to home"
      intro="These Terms and Conditions govern the use of services provided by Luxury Reference, Lda., operating as Vilamoura Dreams Cruises / Morningstar Yacht (RNAAT no. 743/2022)."
      sections={[
        {
          heading: "Bookings",
          body: [
            "All bookings are subject to availability and are confirmed by our concierge after payment is received. Prices are quoted per yacht charter (up to 18 guests).",
          ],
        },
        {
          heading: "Cancellations & Weather",
          body: [
            "Cancellations made by the client more than 14 days before the cruise are fully refundable. Cruises cancelled due to adverse weather will be rescheduled or fully refunded.",
          ],
        },
        {
          heading: "Liability",
          body: [
            "All passengers must follow the safety instructions provided by the crew. The operator is fully insured under Portuguese RNAAT regulations.",
          ],
        },
        {
          heading: "Consumer Arbitration",
          body: [
            'In the event of a consumer dispute, the client may resort to the official Alternative Dispute Resolution entity for the Algarve region: <strong>CIMAAL — Centro de Informação, Mediação e Arbitragem de Conflitos de Consumo do Algarve</strong>. More information at <a class="underline hover:text-gold" href="https://www.consumoalgarve.pt/index.php/pt/" target="_blank" rel="noopener noreferrer">www.consumoalgarve.pt</a>.',
            'Further information on consumer rights is available at the Portuguese Consumer Portal: <a class="underline hover:text-gold" href="https://www.consumidor.gov.pt/" target="_blank" rel="noopener noreferrer">www.consumidor.gov.pt</a>.',
          ],
        },
        {
          heading: "Contact",
          body: [
            'For any question regarding these terms, contact us at <a class="underline hover:text-gold" href="mailto:info@vilamouradreamscruises.com">info@vilamouradreamscruises.com</a>.',
          ],
        },
      ]}
    />
  ),
  head: () =>
    buildHead({
      lang: "en",
      path: PATH,
      title: TITLE,
      description: DESC,
      altPath: { en: PATH, pt: "/pt/termos" },
      extraScripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            breadcrumbLD([
              { name: "Home", path: "/" },
              { name: "Terms & Conditions", path: PATH },
            ]),
          ),
        },
      ],
    }),
});